import * as React from 'react';
import * as PropTypes from 'prop-types';
import { 
  Wrapper,
  TooltipStyled
} from './styled';

interface Props {
  children: React.ReactNode;
  title: string;
  position?: string;
}

export const Tooltip: React.FC<Props> = ({ 
  children, 
  title,
  position
}) => (
  <Wrapper>
    {children}
    <TooltipStyled position={position}>{title}</TooltipStyled>
  </Wrapper>
);

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  position: PropTypes.string
};

Tooltip.displayName = 'Tooltip';